/**
 * Sanitizes text by removing PII before sending to analytics.
 * Strips email addresses, UUIDs, API keys, and other sensitive patterns.
 */
export function sanitizePII(text: string | undefined): string | undefined {
  if (!text) return undefined;

  return (
    text
      // Remove email addresses
      .replace(
        /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g,
        '[EMAIL]',
      )
      // Remove UUIDs (common in our error messages for IDs)
      .replace(
        /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi,
        '[ID]',
      )
      // Remove common API key patterns with known prefixes
      // More conservative than matching all long strings to preserve error context
      .replace(/\b(sk|pk|api|key)_[A-Za-z0-9_-]{16,}\b/gi, '[API_KEY]')
      // Remove phone numbers (basic patterns)
      .replace(/\b\d{3}[-.]?\d{3}[-.]?\d{4}\b/g, '[PHONE]')
      // Remove IP addresses (basic pattern - may match version numbers, which is acceptable)
      .replace(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/g, '[IP]')
  );
}
